import { useQuery, useQueryClient, QueryClient, QueryOptions, QueryResult } from '@eika-infrastruktur/react-query';

import { useConfig } from '../defaultConfig';
import type { PaymentLimits } from '../generated-types';
import { getPaymentLimits } from '../services/paymentLimitsService';

export const PAYMENT_LIMITS_QUERY_KEY = ['payment-limits'];

export const ensurePaymentLimitsData = (
    queryClient: QueryClient,
    enabled: boolean,
): Promise<PaymentLimits | undefined> => {
    if (!enabled) return Promise.resolve(undefined);
    return queryClient.ensureQueryData<PaymentLimits>({ queryKey: PAYMENT_LIMITS_QUERY_KEY }).catch(() => undefined);
};

const usePaymentLimits = (options?: Partial<QueryOptions<PaymentLimits>>): QueryResult<PaymentLimits> => {
    const { featureToggles } = useConfig();
    return useQuery({
        ...options,
        queryKey: PAYMENT_LIMITS_QUERY_KEY,
        queryFn: getPaymentLimits,
        enabled: (options?.enabled ?? true) && featureToggles.enablePaymentLimits,
    });
};

export const useRefreshPaymentLimits = () => {
    const queryClient = useQueryClient();
    return () => queryClient.invalidateQueries({ queryKey: PAYMENT_LIMITS_QUERY_KEY });
};

export default usePaymentLimits;
